module.exports = __webpack_public_path__ + "media/images/icons/twotone/meh-1b296f8182fc4ce7a98c41ddc1a8519a.svg";